import { useMemo } from "react";

import { buildTimeline, positionInterval, snapToYears } from "@/modules/carga-trabalho";

import { DEFAULT_INDICADORES } from "../../../../carga-de-trabalho.constants";
import {
  buildLocalRows,
  extendPeriodoLocal,
} from "@/shared/components/gantt-carga/gantt-local-rows";
import { ganttScaleOf } from "@/shared/components/gantt-carga/gantt-scale";
import type { GanttItem } from "@/shared/components/gantt-carga/gantt-rows";
import { TRANSFERIDA_SUFFIX } from "../../resolver-conflito-local.utils";
import type { RevisaoGanttProps, RevisaoGanttViewModel } from "./types-revisao-gantt";

/** A obra que passa ao substituto é a barra tracejada com a estrela; as demais são as barras de sempre. */
function revisaoItem(item: GanttItem): GanttItem {
  return item.key?.endsWith(TRANSFERIDA_SUFFIX)
    ? { ...item, transferida: true, segments: [{ kind: "transferida", left: 0, width: 100 }] }
    : item;
}

/** Gantt da revisão: os dois locais; o período da substituição em verde e a obra transferida tracejada. */
export function useRevisaoGantt({
  data,
  alocacao,
  periodo,
  today,
}: RevisaoGanttProps): RevisaoGanttViewModel {
  const { rows, timeline, destaque } = useMemo(() => {
    const linha = buildTimeline(snapToYears(extendPeriodoLocal(periodo, data)), alocacao.inicio);
    return {
      timeline: linha,
      destaque: positionInterval(alocacao, linha),
      // Cancelada fica oculta como no Gantt da Carga (RN13): a obra cancelada não ocupa o Local.
      rows: buildLocalRows(data, linha, DEFAULT_INDICADORES, today).map((row) => ({
        ...row,
        items: row.items.map(revisaoItem),
      })),
    };
  }, [data, alocacao, periodo, today]);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);

  return { rows, scale, today, destaque };
}
